module.exports = __webpack_public_path__ + "static/media/40.1af281dd.avif";